<template>
  <div class="footer" v-html="webInfoObj.strFootMessage" > 
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  props: {
    webInfoObj: {
      type: Object,
      default: () => [],
    },
  },
  created() {},
  methods: {},
};
</script>
<style scoped lang="less">
.footer {
  box-sizing: border-box;
  padding: 45px 0;
  text-align: center;
  background-color: #A90C0C;
  color: #fff;
  font-size: 1em;
  font-weight: 400;
  height: 146px;
  line-height: 1.5;
}
</style>